import { SET_STATUS, RESET_STATUS } from "../actions/status";

const initialState = {
  internet: [],
  phone: [],
  tv: []
};

const status = (state = initialState, action) => {
  switch (action.type) {
    case SET_STATUS:
      return action.payload ;
    case RESET_STATUS:
    return initialState;
    default:
      return state;
  }
};

export default status;



// WEBPACK FOOTER //
// ./src/store/reducers/status.js